// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>25</span>&nbsp;&nbsp;Give me justice, O Lord my God,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;according to your righteousness;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let them not triumph over me.<br> </p> </div></div>";
// Exports
module.exports = code;